import Head from "next/head";
import { StaticI18nLink } from "../../../components/Link";
import React, { useState, useRef, useEffect, useMemo } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";

import {
	getAllLandingsSlug,
	getPostAndMorePosts,
} from "../../../services/CMSLandingService";
import { useWindowSize } from "../../../hooks/useWindowResize";

import { Col, Container, Row, Spinner } from "react-bootstrap";
import Header from "../../../components/landings/Header";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import styles from "./landing.module.scss";
import common from "../../../styles/common.module.scss";

import { BsArrowRightShort, BsInstagram } from "react-icons/bs";
import { FiYoutube } from "react-icons/fi";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import {
	FaLaptopCode,
	FaNetworkWired,
	FaHeadset,
	FaShapes,
} from "react-icons/fa";
import { MdPhoneIphone } from "react-icons/md";

SwiperCore.use([Navigation]);
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import IsValidName from "../../../utils/validators/IsValidName";
import IsValidEmail from "../../../utils/validators/IsValidEmail";
import IsValidPhone from "../../../utils/validators/IsValidPhone";
import formatTel from "../../../utils/FormatTel";
import { ApiService } from "../../../services/ApiRequests";
import { Metadata } from "../../../components/Metadata";
import { stripHtml } from "../../../utils/stripHtml";
import Link from "next/link";
import { getI18nProps } from "../../../lib/next-i18next/getStatic";
import { utilityLinks } from "../../../data/contact-info";

const widthBreakpoints = {
	xs: 576, // <=
	sm: 576, // >
	md: 768, // >=
	lg: 992, // >=
	xl: 1200, // >=
	xxl: 1400, // >
	"3xl": 1600, // >=
};

const Mvp = () => {
	return (
		<svg
			width="49"
			height="42"
			viewBox="0 0 49 42"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M12.0625 16.75L6.90625 22.5625L4.75 20.4062C3.90625 19.5625 2.5 19.5625 1.65625 20.4062C0.71875 21.3438 0.71875 22.75 1.65625 23.5938L5.40625 27.3438C5.78125 27.8125 6.34375 28 6.90625 28C7.5625 28 8.125 27.7188 8.5 27.3438L15.25 19.8438C16.0938 18.9062 16.0938 17.5 15.1562 16.6562C14.3125 15.8125 12.9062 15.9062 12.0625 16.75ZM12.0625 1.75L6.90625 7.5625L4.75 5.40625C3.90625 4.5625 2.5 4.5625 1.65625 5.40625C0.71875 6.34375 0.71875 7.75 1.65625 8.59375L5.40625 12.3438C5.78125 12.8125 6.34375 13 6.90625 13C7.5625 13 8.125 12.7188 8.5 12.3438L15.25 4.84375C16.0938 3.90625 16.0938 2.5 15.1562 1.65625C14.3125 0.8125 12.9062 0.90625 12.0625 1.75ZM5.5 32.5C2.96875 32.5 1 34.4688 1 37C1 39.4375 2.96875 41.5 5.5 41.5C7.9375 41.5 10 39.4375 10 37C10 34.5625 7.9375 32.5 5.5 32.5ZM25 10H46C47.5938 10 49 8.6875 49 7C49 5.40625 47.5938 4 46 4H25C23.3125 4 22 5.40625 22 7C22 8.6875 23.3125 10 25 10ZM46 19H25C23.3125 19 22 20.4062 22 22C22 23.6875 23.3125 25 25 25H46C47.5938 25 49 23.6875 49 22C49 20.4062 47.5938 19 46 19ZM46 34H19C17.3125 34 16 35.4062 16 37C16 38.6875 17.3125 40 19 40H46C47.5938 40 49 38.6875 49 37C49 35.4062 47.5938 34 46 34Z" />
		</svg>
	);
};

function LandingPost({ post, morePosts, mainContentWithoutHtml }) {
	const api = new ApiService();

	const [name, setName] = useState("");
	const [businessName, setBusinessName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [knowProject, setKnowProject] = useState("");
	const [privacyPolicy, setPrivacyPolicy] = useState(false);
	const [formSended, setFormSended] = useState(false);
	const [formSendLoading, setFormSendLoading] = useState(false);

	const [sliderItems, setSliderItems] = useState([]);

	const btnPrevSlideLandingTheme = useRef(null);
	const btnNextSlideLandingTheme = useRef(null);
	const dotsWrapperSlideLandingTheme = useRef(null);

	const btnPrevSlideDefaultTheme = useRef(null);
	const btnNextSlideDefaultTheme = useRef(null);
	const dotsWrapperSlideDefaultTheme = useRef(null);

	const size = useWindowSize();

	const isFormValid = () => {
		return (
			!!name &&
			IsValidName(name) &&
			!!businessName &&
			IsValidName(businessName) &&
			!!email &&
			IsValidEmail(email) &&
			!!phone &&
			IsValidPhone(phone) &&
			!!knowProject &&
			!!privacyPolicy
		);
	};

	const handleSubmitContactForm = async (e) => {
		e.preventDefault();
		if (formSended) return;

		setFormSendLoading(true);

		if (isFormValid()) {
			try {
				const response = await api.makeHttpRequest({
					url: "/contact-us",
					method: "post",
					data: {
						name,
						email,
						subject: `
              Empresa: ${businessName}, 
              Telefone: ${phone}, 
              Landing Page: ${post?.metadata?.secao_principal.titulo_da_pagina}, 
              Mensagem: ${knowProject}
            `,
					},
				});

				setFormSended(true);
				dispatchEventLeadConversion();

				setName("");
				setBusinessName("");
				setEmail("");
				setPhone("");
				setKnowProject("");
			} catch (error) {
				console.error(error);
				alert(
					`Canal indisponível, favor entrar em contato via WhatsApp pelo número: ${process.env.NEXT_PUBLIC_WHATSAPP}`,
				);
			}
		}

		setFormSendLoading(false);
	};

	const dispatchEventLeadConversion = () => {
	  	const isLinkedinLead =
		    typeof window !== "undefined" &&
    		window.location.search.indexOf("utm_source=linkedin") !== -1;

		  if (
    		!isLinkedinLead &&
    		typeof window !== "undefined" &&
    		typeof window.gtag === "function" &&
    		process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERTION
  		) {
    		window.gtag("event", "conversion", {
      		send_to: process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERTION,
    		});
  		}
	};

	const groupItemsInSliderPerColumn = (itemsForGroup, columns = 3) => {
		if (!itemsForGroup?.length) return [];
		if (columns < 1) return [];

		if (columns === 1) {
			return itemsForGroup;
		}

		let howMuchTimesHasGroup = Math.trunc(itemsForGroup.length / columns);
		const howMuchItemsLeftInGroup = itemsForGroup.length % columns;

		let lastIndexGrouped = 0;
		const itemsHandled = itemsForGroup.reduce((groupAcc, _, index) => {
			if (index < lastIndexGrouped) return groupAcc;

			const indexInArray = index === 1 ? 0 : index;
			const finalIndexSliced = indexInArray + columns;

			if (!howMuchTimesHasGroup && howMuchItemsLeftInGroup) {
				const groupedItem = itemsForGroup.slice(
					indexInArray,
					indexInArray + howMuchItemsLeftInGroup,
				);

				lastIndexGrouped = finalIndexSliced;
				return [...groupAcc, groupedItem];
			}

			const group = itemsForGroup.slice(indexInArray, finalIndexSliced);

			howMuchTimesHasGroup -= 1;
			lastIndexGrouped = finalIndexSliced;
			return [...groupAcc, group];
		}, []);

		return itemsHandled;
	};

	const onBeforeInitLandingThemeSlide = (Swiper) => {
		if (typeof Swiper.params.navigation !== "boolean") {
			const navigation = Swiper.params.navigation;
			navigation.prevEl = btnPrevSlideLandingTheme.current;
			navigation.nextEl = btnNextSlideLandingTheme.current;
		}

		if (typeof Swiper.params.pagination !== "boolean") {
			Swiper.params.pagination.el = dotsWrapperSlideLandingTheme.current;
		}
	};

	const onBeforeInitDefaultThemeSlide = (Swiper) => {
		if (typeof Swiper.params.navigation !== "boolean") {
			const navigation = Swiper.params.navigation;
			navigation.prevEl = btnPrevSlideDefaultTheme.current;
			navigation.nextEl = btnNextSlideDefaultTheme.current;
		}

		if (typeof Swiper.params.pagination !== "boolean") {
			Swiper.params.pagination.el = dotsWrapperSlideDefaultTheme.current;
		}
	};

	useEffect(() => {
		// Utilizado para tratar as duas colunas presente no slide
		// uma vez que a biblioteca não fornece essa api.

		if (
			size.width >= widthBreakpoints.xxl &&
			post?.metadata?.slider_de_servico.length <= 4
		) {
			return;
		}

		const allPosts = post?.metadata?.slider_de_servico?.map((service) => {
			return (
				<React.Fragment key={service.titulo}>
					<div className={styles.card_landing_theme}>
						<img src={service.icone.url} alt="" />
						<h4>{service.titulo}</h4>
						<div dangerouslySetInnerHTML={{ __html: service.conteudo }}></div>
					</div>
				</React.Fragment>
			);
		});

		const landingThemeCardServices = groupItemsInSliderPerColumn(
			allPosts,
			size.width >= widthBreakpoints.lg ? 1 : 2,
		);

		setSliderItems(landingThemeCardServices);
	}, [post?.metadata?.slider_de_servico, size.width]);

	return (
		<Container fluid className="g-0">
			<Metadata post={post} mainContent={mainContentWithoutHtml} />

			<Header />

			<Row
				as="section"
				className={`g-0 ${styles.section} ${styles.banner} ${common.container}`}
			>
				{size.width >= widthBreakpoints.md ? (
					<>
						<Col xs={5} md={7} className={styles.bannerContent}>
							<h1 className={`${styles.title}`}>
								Precisando de <br />
								<span>{post?.metadata?.secao_principal.titulo_da_pagina}?</span>
								<br />
								<p>Você está no lugar certo!</p>
							</h1>

							<div className={styles.ctaContainer}>
								<a
									target="_blank"
									href={`https://api.whatsapp.com/send?phone=${process.env.NEXT_PUBLIC_WHATSAPP}&text=Olá, preciso de ajuda referente a ${post?.title}, podemos conversar?`}
									onClick={() => dispatchEventLeadConversion()}
									rel="noreferrer"
								>
									<Button text="Vamos conversar?" />
									<span id={styles.whatsAppLogo}>
										<img
											src="/landings/assets/icons/whatsapp.svg"
											alt="whatsapp"
										></img>
									</span>
								</a>
							</div>
						</Col>
						<Col xs={{ span: 5, offset: 1 }} className={styles.bannerImg}>
							<img
								src={post?.metadata?.secao_principal?.imagem?.url}
								alt="Imagem principal"
							/>
						</Col>
					</>
				) : (
					<>
						<Col xs={12}>
							<h1 className={`${styles.title}`}>
								Precisando de{" "}
								<span>{post?.metadata?.secao_principal.titulo_da_pagina}?</span>
							</h1>

							<h1 className={`${styles.title}`}> Você está no lugar certo!</h1>
							<div className={styles.bannerImg}>
								<img
									src={post?.metadata?.secao_principal?.imagem?.url}
									alt="Imagem principal"
								/>
							</div>
						</Col>
						<Col xs={12}>
							<div className={styles.ctaContainer}>
								<a
									target="_blank"
									href={`https://api.whatsapp.com/send?phone=${process.env.NEXT_PUBLIC_WHATSAPP}&text=Olá, preciso de ajuda referente a ${post?.title}, podemos conversar?`}
									onClick={() => dispatchEventLeadConversion()}
									rel="noreferrer"
								>
									<Button text="Vamos conversar?" />
									<span id={styles.whatsAppLogo}>
										<img
											src="/landings/assets/icons/whatsapp.svg"
											alt="whatsapp"
										></img>
									</span>
								</a>
							</div>
						</Col>
					</>
				)}
			</Row>

			<Row
				as="section"
				className={`g-0 mb-0 ${styles.section} ${styles.wrapper_content_cms} ${common.container}`}
			>
				<h1 className={styles.titlecentered}>
					Uma equipe que ajuda você a moldar ideias
				</h1>

				<Col xs={12} lg={5} className={styles.img_cms}>
					<img
						src={
							post?.metadata?.imagem_conteudo?.url ||
							post?.metadata?.secao_principal?.imagem?.url
						}
						alt=""
					/>
				</Col>

				<Col
					xs={12}
					lg={{ span: 4, offset: 1 }}
					className={styles.content_cms}
					dangerouslySetInnerHTML={{
						__html: post?.metadata?.secao_principal?.conteudo_principal,
					}}
				/>
			</Row>

			<Col
				xs={12}
				className={`${styles.slide_landing_theme_wrapper} ${styles.section} ${common.container}`}
			>
				{size.width >= widthBreakpoints.xxl &&
				post?.metadata?.slider_de_servico.length <= 4 ? (
					<div className={styles.container_services_default}>
						{post?.metadata?.slider_de_servico?.map((service) => {
							return (
								<React.Fragment key={service.titulo}>
									<div className={styles.card_landing_theme}>
										<img src={service.icone.url} alt="" />
										<h4>{service.titulo}</h4>
										<div
											dangerouslySetInnerHTML={{ __html: service.conteudo }}
										></div>
									</div>
								</React.Fragment>
							);
						})}
					</div>
				) : (
					<Swiper
						navigation={{
							nextEl: btnNextSlideLandingTheme.current,
							prevEl: btnPrevSlideLandingTheme.current,
						}}
						pagination={{
							type: "bullets",
							clickable: true,
							el: dotsWrapperSlideLandingTheme.current,
						}}
						onBeforeInit={onBeforeInitLandingThemeSlide}
						className={styles.slide_wrapper}
						modules={[Navigation, Pagination]}
						breakpoints={{
							[widthBreakpoints.sm]: { slidesPerView: 1 },
							[widthBreakpoints.md]: { slidesPerView: 1 },
							[widthBreakpoints.lg]: { slidesPerView: 2 },
							[widthBreakpoints.xxl]: { slidesPerView: 4 },
						}}
						spaceBetween={20}
						loop
					>
						{!!sliderItems.length &&
							sliderItems.map((cards, i) => {
								return (
									<SwiperSlide key={i}>
										{Array.isArray(cards)
											? cards.map((card, indice) => {
													return (
														<React.Fragment key={indice}>{card}</React.Fragment>
													);
												})
											: cards}
									</SwiperSlide>
								);
							})}

						<div className={styles.navigation_wrapper}>
							<div className={styles.prev_slide} ref={btnPrevSlideLandingTheme}>
								<IoMdArrowRoundBack />
							</div>
							<div
								className={styles.dots_pagination}
								ref={dotsWrapperSlideLandingTheme}
							></div>
							<div className={styles.next_slide} ref={btnNextSlideLandingTheme}>
								<IoMdArrowRoundForward />
							</div>
						</div>
					</Swiper>
				)}
			</Col>

			<Row
				as="section"
				className={`g-0 ${styles.section} ${styles.services_container} ${common.container}`}
			>
				<h1 className={styles.title}>Nossos serviços</h1>

				<div className={styles.ourServicesWrapper}>
					{size.width >= widthBreakpoints.xxl ? (
						<div
							className={`${styles.card_default_theme_services_wrapper} ${styles.slide_default_theme_wrapper}`}
						>
							<div className={styles.card_default_theme_services}>
								<MdPhoneIphone aria-describedby="Ícone representando celular" />
								<h3>Aplicações Mobile</h3>
								<p>
									Desenvolvimento de <b>aplicativos iOS e Android</b>, nativos
									ou construídos.
								</p>
							</div>
							<div className={styles.card_default_theme_services}>
								<FaLaptopCode aria-describedby="Ícone representando Web Design & Dev" />
								<h3>Web Design & Dev</h3>
								<p>
									Layouts personalizados, utilizando <b>conceitos de UX/UI</b>.
									Páginas responsivas e otimizadas.
								</p>
							</div>

							<div className={styles.card_default_theme_services}>
								<Mvp />

								<h3>MVP & Prototipação</h3>
								<p>
									Criamos o protótipo com o <b>foco em feedbacks</b>, validando
									a solução da ideia.
								</p>
							</div>
							<div className={styles.card_default_theme_services}>
								<FaNetworkWired aria-describedby="Ícone representando Integrações" />
								<h3>Integrações</h3>
								<p>
									Realizamos qualquer <b>tipo de integração</b> com APIs Rest,
									hardware, microsserviços, etc.
								</p>
							</div>

							<div className={styles.card_default_theme_services}>
								<FaShapes aria-describedby="ícone representando Product Management" />

								<h3>Product Management</h3>
								<p>
									Organizamos todos os passos, permitindo{" "}
									<b>testar e adaptar</b> a possíveis mudanças com agilidade.
								</p>
							</div>
							<div className={styles.card_default_theme_services}>
								<FaHeadset aria-describedby="Ícone representando Suporte" />
								<h3>Suporte</h3>
								<p>
									<b>Suporte 24 / 7 </b> que garante a disponibilidade e
									segurança dos produtos desenvolvidos.
								</p>
							</div>
						</div>
					) : (
						<Swiper
							navigation={{
								nextEl: btnNextSlideDefaultTheme.current,
								prevEl: btnPrevSlideDefaultTheme.current,
							}}
							pagination={{
								type: "bullets",
								clickable: true,
								el: dotsWrapperSlideDefaultTheme.current,
							}}
							onBeforeInit={onBeforeInitDefaultThemeSlide}
							className={`${styles.slide_wrapper} ${styles.slide_default_theme_wrapper}`}
							modules={[Navigation, Pagination]}
							breakpoints={{
								[widthBreakpoints.xs]: { slidesPerView: 1 },
								[widthBreakpoints.lg]: { slidesPerView: 2 },
							}}
							slidesPerView={1}
							spaceBetween={20}
							loop
						>
							<SwiperSlide>
								<div className={styles.card_default_theme_services}>
									<MdPhoneIphone aria-describedby="Ícone representando celular" />
									<h3>Aplicações Mobile</h3>
									<p>
										Desenvolvimento de aplicativos iOS e Android, nativos ou
										construídos.
									</p>
								</div>
								<div className={styles.card_default_theme_services}>
									<FaLaptopCode aria-describedby="Ícone representando Web Design & Dev" />
									<h3>Web Design & Dev</h3>
									<p>
										Layouts personalizados utilizando conceitos de UX/UI.
										Páginas responsivas e otimizadas.
									</p>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div className={styles.card_default_theme_services}>
									<img
										src="/landings/assets/icons/list-check.svg"
										alt="Ícone representando MVP & Prototipação"
									/>

									<h3>MVP & Prototipação</h3>
									<p>
										Criamos o protótipo com o foco em feedbacks, validando a
										solução da ideia.
									</p>
								</div>
								<div className={styles.card_default_theme_services}>
									<FaNetworkWired aria-describedby="Ícone representando Integrações" />
									<h3>Integrações</h3>
									<p>
										Aplicações e integrações utilizando tecnologias como APIs
										Rest, microsserviços.{" "}
									</p>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div className={styles.card_default_theme_services}>
									<img
										src="/landings/assets/icons/shapes.svg"
										alt="Ícone representando Product Management"
									/>

									<h3>Product Management</h3>
									<p>
										Organizamos todos os passos, permitindo testar e adaptar à
										possíveis mudanças com agilidade
									</p>
								</div>
								<div className={styles.card_default_theme_services}>
									<FaHeadset aria-describedby="Ícone representando Suporte" />
									<h3>Suporte</h3>
									<p>
										Suporte 24 / 7 que garante a disponibilidade e segurança dos
										produtos desenvolvidos.
									</p>
								</div>
							</SwiperSlide>

							<div className={styles.navigation_wrapper}>
								<div
									className={styles.prev_slide}
									ref={btnPrevSlideDefaultTheme}
								>
									<IoMdArrowRoundBack />
								</div>
								<div
									className={styles.dots_pagination}
									ref={dotsWrapperSlideDefaultTheme}
								></div>
								<div
									className={styles.next_slide}
									ref={btnNextSlideDefaultTheme}
								>
									<IoMdArrowRoundForward />
								</div>
							</div>
						</Swiper>
					)}
				</div>
			</Row>

			<Row
				as="section"
				id="contato"
				className={`g-0 ${styles.section} ${styles.contact_form_container} ${common.container}`}
			>
				<Col as="form" xs={12} lg={8} onSubmit={handleSubmitContactForm}>
					<h1 className={styles.titleWhite}>Vamos conversar?</h1>
					<div className={styles.contact_form_wrapper}>
						<p>
							Estamos curiosos e animados para conhecer melhor você e sua
							empresa. Conte-nos sobre sua necessidade ou ideia que nós
							entraremos em contato.
						</p>
						<p>
							Nossa empresa está localizado em São Paulo e será um prazer te
							receber para um café.
						</p>
					</div>

					<Row className={`g-3 ${styles.form_wrapper}`}>
						<Col xs={12} md={6}>
							<Input
								type="text"
								onChange={(e) => setName(e.currentTarget.value)}
								value={name}
								placeholder="Nome e sobrenome*"
								isinvalid={(name && !IsValidName(name)).toString()}
							/>
						</Col>

						<Col xs={12} md={6}>
							<Input
								type="text"
								onChange={(e) => setBusinessName(e.currentTarget.value)}
								value={businessName}
								placeholder="Empresa*"
								isinvalid={(
									businessName && !IsValidName(businessName)
								).toString()}
							/>
						</Col>
						<Col xs={12} md={6}>
							<Input
								type="email"
								onChange={(e) => setEmail(e.currentTarget.value)}
								value={email}
								placeholder="E-mail*"
								isinvalid={(email && !IsValidEmail(email)).toString()}
							/>
						</Col>
						<Col xs={12} md={6}>
							<Input
								type="text"
								onChange={(e) => setPhone(e.currentTarget.value)}
								value={formatTel(phone)}
								placeholder="Telefone*"
								isinvalid={(phone && !IsValidPhone(phone)).toString()}
							/>
						</Col>

						<Col xs={12}>
							<textarea
								className={`${styles.input_text_area} ${
									knowProject && knowProject.length < 3 ? styles.isInvalid : ""
								}`}
								rows="6"
								value={knowProject}
								onChange={(e) => setKnowProject(e.currentTarget.value)}
								placeholder="Mensagem*"
							/>
						</Col>
						<div className={styles.checkboxWrapper}>
							<Col xs={12} md={8}>
								<div className={styles.checkbox_form}>
									<Input
										id="checkbox_privacity_policy"
										value={privacyPolicy}
										onChange={() => setPrivacyPolicy(!privacyPolicy)}
										type="checkbox"
										isinvalid={(!privacyPolicy).toString()}
									/>
									<label
										htmlFor="checkbox_privacity_policy"
										className={styles.checkbox_description}
									>
										Aceito Compartilhar minhas informações com a Verzel, e estou
										ciente da{" "}
										<a
											href="/pt/privacy-policy"
											target="_blank"
											rel="noreferrer"
										>
											<u>Política de Privacidade</u>
										</a>
									</label>
								</div>
							</Col>
							<Button
								className={styles.buttonForm}
								formSended={!formSended}
								type="submit"
								text="Enviar Contato"
								isloading={formSendLoading}
								// disabled={!isFormValid()}
							/>
						</div>
					</Row>
				</Col>

				<div className={styles.cellphone_img}>
					<img
						src="/landings/assets/images/ImgCelular.svg"
						alt="Imagem simbolizando projetos mobiles e web"
					/>
				</div>
			</Row>

			<div className={styles.found_us_section}>
				<address>
					<Link href="mailto:contato@verzel.com.br">
						<a>contato@verzel.com.br</a>
					</Link>
					<br />
					<p>
						Rua Aníbal Benévolo, 94 - 2° Andar Santana - São Paulo/SP - CEP
						02016-040
					</p>
				</address>
			</div>

			<footer className={styles.footer}>
				<div className={styles.content}>
					<img
						className={styles.footer_logo}
						src="/landings/assets/images/logo_devaria.svg"
						alt="Logo devaria"
					/>

					<p id="devaria">
						A Devaria, outra empresa do nosso grupo, desenvolve projetos visando
						atender às necessidades de treinamentos do mercado.{" "}
						<strong>
							Precisa de um treinamento especializado para sua empresa?
						</strong>{" "}
						Liberamos uma plataforma exclusiva para gestão de qualquer
						treinamento interno que você necessite!
					</p>

					<div className={styles.ctaFooter}>
						<Link href="https://www.devaria.com.br/para-empresas">
							<a title="Link para o site da devaria">
								<img
									src="/landings/assets/icons/world-icon.svg"
									alt="ícone que simboliza web"
								/>
								<span>devaria.com.br</span>
							</a>
						</Link>
						<Link href="https://youtube.com/c/devaria">
							<a title="Link para o canal do youtube da devaria">
								<FiYoutube aria-describedby="Ícone simbolizando youtube" />
								<span>youtube.com/c/devaria</span>
							</a>
						</Link>
						<Link href="https://www.instagram.com/devaria.tech/">
							<a title="Link para o instagram da devaria">
								<BsInstagram aria-describedby="Ícone simbolizando instagram" />
								<span>@devaria_oficial</span>
							</a>
						</Link>
					</div>
				</div>
			</footer>

			<div className={styles.footer_navigation}>
				<ul>
					<li>
						<StaticI18nLink href="/#dev-sistemas">
							<a title="Link para Sobre a Verzel">Sobre a Verzel</a>
						</StaticI18nLink>
					</li>
					<li>
						<StaticI18nLink href="/#contact-us">
							<a title="Link para Contato">Contato</a>
						</StaticI18nLink>
					</li>
					<li>
						<StaticI18nLink href="/#devaria">
							<a title="Link para Devaria">Devaria</a>
						</StaticI18nLink>
					</li>
					<li>
						<Link href={utilityLinks.workWithUs}>
							<a target="_blank" title="Link para Trabalhe Conosco">Trabalhe Conosco</a>
						</Link>
					</li>
					<li>
						<StaticI18nLink href="/privacy-policy">
							<a title="Link para Termos e Política de Privacidade">
								Termos e Política de Privacidade
							</a>
						</StaticI18nLink>
					</li>
				</ul>
			</div>
		</Container>
	);
}

export async function getStaticProps(ctx) {
  const i18nProps = await getI18nProps(ctx);
	const data = await getPostAndMorePosts(ctx?.params.slug);

	return {
		props: {
			...i18nProps,
			post: {
				...data?.post,
			},
			morePosts: data?.morePosts || [],
			mainContentWithoutHtml: stripHtml(data?.post?.metadata?.meta_description),
		},
	};
}

export async function getStaticPaths() {
	const allPosts = (await getAllLandingsSlug()) || [];

	return {
		paths: allPosts.map((post) => ({
			params: {
				locale: 'pt',
				slug: post.slug
			}
		})),
		fallback: true,
	};
}

export default LandingPost;
